module.exports = __webpack_public_path__ + "static/media/mobile_archero2_page_area04_img_en@2x.47a76bed.png";